// extracted by mini-css-extract-plugin
export var aircallIframe = "_cg-3";
export var fabContainer = "_cg-5";
export var fabRinging = "_cg-6";
export var loadingOverlay = "_cg-4";
export var pulse = "_cg-7";
export var widgetContent = "_cg-2";
export var widgetPanel = "_cg-0";
export var widgetPanelExpanded = "_cg-1";